import { Context, UpdatePaymentDetailsParams } from '../../../types';
import { PaymentDetails } from '@vsf-enterprise/sap-commerce-webservices-sdk';
import { UpdatePaymentDetailsProps } from '@vsf-enterprise/sapcc-api';
import { createBasePropsFromCustomQuery } from '../../../helpers/createBasePropsFromCustomQuery';

export const disableOldDefaultPaymentDetails = async (
  context: Context,
  params: UpdatePaymentDetailsParams
): Promise<Readonly<PaymentDetails[]>> => {
  const oldDefault = params.paymentDetailsList?.find(
    (details) => details.defaultPayment
  );

  if (!oldDefault || oldDefault.id === params.paymentDetails.id)
    return params.paymentDetailsList;

  return updatePaymentDetails(context, {
    ...params,
    paymentDetails: { ...oldDefault, defaultPayment: false }
  });
};

export async function updatePaymentDetails(
  context: Context,
  params: UpdatePaymentDetailsParams
): Promise<PaymentDetails[]> {
  const { paymentDetails, paymentDetailsList, customQuery } = params;
  const id = paymentDetails.id;

  const props: UpdatePaymentDetailsProps = {
    paymentDetailsId: paymentDetails.id,
    paymentDetails: paymentDetails,
    ...createBasePropsFromCustomQuery(customQuery)
  };

  await context.$sapcc.api.updatePaymentDetails(props);

  let list = paymentDetailsList;

  if (paymentDetails.defaultPayment) {
    list = await disableOldDefaultPaymentDetails(context, params);
  }

  const clonedList = [...list];
  const index = clonedList.findIndex((e) => e.id === id);
  if (!~index) throw new Error(`PaymentDetails with id ${id} not found`);

  clonedList[index] = paymentDetails;

  return clonedList;
}
